export const LOG_ACTIONS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];

export default LOG_ACTIONS;



// WEBPACK FOOTER //
// ./src/store/modules/log/constants.js